import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="h-[70px] bg-white flex items-center sticky top-0 z-[1000] border-b border-border-light">
      <div className="w-full max-w-[1300px] mx-auto px-6 md:px-8 flex justify-between items-center">
        <Link to="/" className="flex items-center" onClick={() => setIsOpen(false)}>
          <img src="/logo.jpeg" alt="BASCO Distribution" className="h-[35px] w-auto object-contain" />
        </Link>
        
        {/* Desktop Menu */}
        <ul className="hidden lg:flex gap-8">
          <li><Link to="/#why-choose" className="text-text-dark font-medium text-[0.95rem] hover:text-primary-red transition-colors">Why BASCO</Link></li>
          <li><Link to="/#categories" className="text-text-dark font-medium text-[0.95rem] hover:text-primary-red transition-colors">Categories</Link></li>
          {/* <li><Link to="/inventory" className="text-text-dark font-medium text-[0.95rem] hover:text-primary-red transition-colors">Inventory</Link></li> */}
          <li><Link to="/#wholesale" className="text-text-dark font-medium text-[0.95rem] hover:text-primary-red transition-colors">Wholesale</Link></li>
          {/* <li><Link to="/inquiry-success" className="text-text-dark font-medium text-[0.95rem] hover:text-primary-red transition-colors">Inquiry Status</Link></li> */}
        </ul>

        <div className="hidden lg:flex gap-4">
          <Link to="/#apply" className="bg-primary-red text-white px-[1.2rem] py-[0.6rem] rounded-[12px] font-semibold text-[0.9rem] hover:bg-primary-hover shadow-sm transition-all hover:shadow-md">New Accounts</Link>
        </div>

        {/* Mobile Toggle */}
        <button 
          className="lg:hidden flex flex-col gap-1.5 p-2"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className={`w-6 h-0.5 bg-text-dark transition-all duration-300 ${isOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
          <span className={`w-6 h-0.5 bg-text-dark transition-all duration-300 ${isOpen ? 'opacity-0' : ''}`}></span>
          <span className={`w-6 h-0.5 bg-text-dark transition-all duration-300 ${isOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`lg:hidden fixed inset-0 top-[70px] bg-white z-[999] transition-all duration-300 transform ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <ul className="flex flex-col p-8 gap-6">
          <li><Link to="/#why-choose" className="text-[1.1rem] font-semibold text-text-dark" onClick={() => setIsOpen(false)}>Why BASCO</Link></li>
          <li><Link to="/#categories" className="text-[1.1rem] font-semibold text-text-dark" onClick={() => setIsOpen(false)}>Categories</Link></li>
          {/* <li><Link to="/inventory" className="text-[1.1rem] font-semibold text-text-dark" onClick={() => setIsOpen(false)}>Inventory</Link></li> */}
          <li><Link to="/#wholesale" className="text-[1.1rem] font-semibold text-text-dark" onClick={() => setIsOpen(false)}>Wholesale</Link></li>
          {/* <li><Link to="/inquiry-success" className="text-[1.1rem] font-semibold text-text-dark" onClick={() => setIsOpen(false)}>Inquiry Status</Link></li> */}
          <li className="pt-4">
            <Link to="/#apply" className="bg-primary-red text-white px-6 py-3 rounded-xl font-bold text-center block" onClick={() => setIsOpen(false)}>New Accounts</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
